import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from 'tss-react/mui';
import { TranslationWithParams, useLang } from 'src/app/i18n';
import { localeMapToBackend } from 'src/app/modules/AgentProfile/common/utils/locale-utils';
import { AgentProfileItem } from 'src/app/modules/AgentProfile/types/agent-profile-types';

type BasicInfoProps = {
  agentProfile: AgentProfileItem;
};

const useStyles = makeStyles()((theme) => ({
  agentNameStyle: {
    fontSize: 20,
    paddingTop: 4,
    fontWeight: 700,
  },
  informationContainer: {
    fontSize: 14,
  },
  informationContentStyle: {
    paddingTop: 4,
  },
}));

const BasicInfo: FC<BasicInfoProps> = ({ agentProfile }) => {
  const { classes } = useStyles();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const currentLang = useLang();
  const mappedLocale = localeMapToBackend[currentLang] || currentLang;

  const { lbuName, designation, license, yearOfExperience, numberOfServicedCustomer } = agentProfile.agentDetail;

  const getDisplayServicedCustomer = () => {
    if (!numberOfServicedCustomer || numberOfServicedCustomer < 50) {
      return;
    } else if (numberOfServicedCustomer < 100) {
      return 50;
    } else if (numberOfServicedCustomer < 200) {
      return 100;
    } else if (numberOfServicedCustomer < 300) {
      return 200;
    } else if (numberOfServicedCustomer < 500) {
      return 300;
    }
    return 500;
  };

  const getAgentIntroduction = () => {
    const key = 'agentProfile.ap_agent_introduction';
    const year = Math.trunc(Number(yearOfExperience || 0) / 5) * 5;
    const num3 = getDisplayServicedCustomer();
    const params = {
      num1: license.gi === 'Y' ? Translation(key + '_num1') : '',
      num2: year >= 5 ? TranslationWithParams(key + '_num2', { num: year }) : '',
      num3: num3 ? TranslationWithParams(key + '_num3', { num: num3 }) : '',
    };
    return TranslationWithParams('agentProfile.ap_agent_introduction', params);
  };

  const getServiceScope = () => {
    const str = currentLang === 'en' ? ', ' : '、';
    const key = 'agentProfile.ap_service_scope';
    const params = {
      num1: license.inv_link ? str + Translation(key + '_num1') : '',
      num2: license.gi === 'Y' ? str + Translation(key + '_num2') : '',
      num3: license.mpf ? str + Translation(key + '_num3') : '',
    };
    return TranslationWithParams(key, params);
  };

  return (
    <>
      <div className={classes.agentNameStyle}>{agentProfile.name[mappedLocale]}</div>
      <div className={classes.informationContainer}>
        {agentProfile.achievements && agentProfile.achievements.length !== 0 && (
          <div className={classes.informationContentStyle}>{agentProfile.achievements.join(', ')}</div>
        )}
        {designation[mappedLocale] && (
          <div className={classes.informationContentStyle}>{designation[mappedLocale]}</div>
        )}
        {/* {lbuName && lbuName[mappedLocale] && (
          <div className={classes.informationContentStyle}>{lbuName[mappedLocale]}</div>
        )}
        {license.gi === 'Y' && (
          <div className={classes.informationContentStyle}>{Translation('agentProfile.ap_pgihk_label')}</div>
        )} */}
        <div className={classes.informationContentStyle}>{getAgentIntroduction()}</div>
        <div className={classes.informationContentStyle}>{getServiceScope()}</div>
        {license.hkfi && (
          <div className={classes.informationContentStyle}>
            {Translation('agentProfile.ap_ia_license_label')}: {license.hkfi}
          </div>
        )}
        {license.mpf && (
          <div className={classes.informationContentStyle}>
            {Translation('agentProfile.ap_mpf_license_label')}: {license.mpf}
          </div>
        )}
        {license.sfc && (
          <div className={classes.informationContentStyle}>
            {Translation('agentProfile.ap_sfc_license_label')}: {license.sfc}
            <br />
            {Translation('agentProfile.ap_sfc_license_statement')}
          </div>
        )}
      </div>
    </>
  );
};

export default BasicInfo;
